module.exports = __webpack_public_path__ + "img/bg-section-01-mobile.ed9eb08a.svg";